<template>
	<div class="page" data-name="notice">
		<div class="page-content infinite-scroll-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					공지사항
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
			</f7-navbar>

			<div class="list">
				<ul>								
					<template v-for="(item,i) in boardList">		
						<li :key="'ii' + i">
							<a href="#" class="item-link item-content popup-open" data-popup=".notice-view-popup" v-on:click="setNoticeData(item)">							
								<div class="item-inner">
									<div class="item-title">
										<div class="item-header">{{boardTypeDisplay(item.NOTICE_TYPE)}}</div>
										 {{item.TITLE}}
									</div>
									<div class="item-after">{{displayUpdataTime(item.UPDATE_DATETIME)}}</div>
								</div>
							</a>
						</li>
					</template>
				</ul>					
			</div>
			<div class="preloader infinite-scroll-preloader" style="display:none"></div>
		</div>

		<div class="popup notice-view-popup" id="notice-view-popup">
			<div class="view">
				<div class="page">
					<div class="navbar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner">
							<div class="title">{{noticeType}}</div>
							<div class="right">								
								<a class="link popup-close">닫기</a>
							</div>
						</div>
					</div>
					<div class="page-content">	
						<div class="block-title block-title-medium">{{title}}</div>	
						<div class="block">
							 <p v-html="content"></p>
						</div>									
					</div>					
				</div>
			</div>			
		</div>	

	</div>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import AUTH from '../../../js/common/auth';

export default {
	data(){				
		return{
			title:	"",
			content: "",
			updateDatetime: "",		
			noticeType:"",	
			pageNo: 1,
			pageSize: 30,
			boardList: [],	
			allowInfinite: true,
			maxPageNo:0			
		}
	},
	mounted(){    
		const _this = this;
	//	$(document).on('page:init page:reinit','.page[data-name="notice"]',	_this.onPageShow);
		$('.infinite-scroll-content').on('infinite',_this.onInfinite);
		_this.onPageShow();	
	},
	methods:{
		onPageShow(e){
			const _this = this;			
			_this.loadNoticeList();
		},
		onInfinite(){
			const _this = this;

			if(!_this.allowInfinite) return;
			_this.allowInfinite = false;
			
			$('.infinite-scroll-preloader').show();				
			
			setTimeout(function () {
				_this.allowInfinite = true;

				if(_this.pageNo >= _this.maxPageNo){			
					_this.$f7.infiniteScroll.destroy('.infinite-scroll-content');
					$('.infinite-scroll-preloader').remove();				
      		return;
				}
					 		
				_this.loadNoticeList();

			}, 1000);
		},	
		loadNoticeList(){
			const _this = this;

			let param = {
				pTitle : _this.title,
				pPageNo : _this.pageNo,
				pPageSize : _this.pageSize
			}
			
			API.ajaxRequest({
				url: API.getNoticeList(),
				data: param
			}).then(function (data){

			 if(data.boardList.length > 0) {

					for(var i = 0; i < data.boardList.length; i++) {
						var boardItem  =  data.boardList[i];
						_this.boardList.push(boardItem);						
					 }						 
					 
					_this.pageNo += 1;	
				 	_this.maxPageNo = data.totalPageCount;				
				}				
				$('.infinite-scroll-preloader').hide();

			}).catch(function (code){
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		boardTypeDisplay(boardType){

			if(boardType == "hoff"){
				return "본사공지";
			}else{
				return "학원공지";
			}
		},
		displayUpdataTime(updateTime){
			var formatDate = moment(updateTime).format("YYYY-MM-DD");			
			return formatDate;
		},
		setNoticeData(noticeItem){
			const _this = this;			
			_this.title = noticeItem.TITLE;
			_this.content = noticeItem.CONTENT;
			_this.noticeType = _this.boardTypeDisplay(noticeItem.NOTICE_TYPE);
			_this.updateDatetime = _this.displayUpdataTime(noticeItem.UPDATE_DATETIME);

		}
	}
	
}
</script>